import React, { useState } from 'react';
import AchievementLevel from 'components/AchievementLevel';
import RecommendedSeals from 'components/RecommendedSeals';
import AchievementsPageReady from './AchievementsPageReady';
import { getDashboardAchievementsQuery } from './query';

const useDashboardAchievements = () => {
  const [achievements, setAchievements] = useState(null);
  const isCounting = achievements?.unlocked === true && !achievements.stats;
  const onAchievements = (response) => {
    setAchievements(response.data.data.achievements);
  };
  return { achievements, isCounting, onAchievements };
};

const DashboardCards = ({ achievements }) => {
  if (!achievements?.unlocked || !achievements.stats) {
    return null;
  }
  return (
    <div className="dashboard__achievements">
      <AchievementLevel
        currentLevel={achievements.current_level}
        nextLevel={achievements.next_level}
      />
      <RecommendedSeals seals={achievements.recommended_seals} />
    </div>
  );
};

const DashboardAchievements = () => {
  const { achievements, isCounting, onAchievements } =
    useDashboardAchievements();
  return (
    <AchievementsPageReady
      query={getDashboardAchievementsQuery()}
      isCounting={isCounting}
      onData={onAchievements}>
      <DashboardCards achievements={achievements} />
    </AchievementsPageReady>
  );
};

export default DashboardAchievements;
